import React from 'react';

import { HomeIconButton } from '../home-icon-button';
import classNames from './EABDScreenHeader.module.scss';

export interface ScreenHeaderProps
  extends Readonly<{
    shouldShowHome: boolean;
    children?: React.ReactNode;
    onHomePress?: () => void;
  }> {}

export const ScreenHeader = React.memo<ScreenHeaderProps>((props) => {
  const { shouldShowHome, onHomePress = () => undefined, children } = props;

  const OnHomePressCallback = React.useCallback(() => onHomePress(), [onHomePress]);

  const HomeIconButtonElement = React.useMemo<JSX.Element>(() => {
    if (shouldShowHome) {
      return <HomeIconButton onPress={OnHomePressCallback} />;
    }

    return <div className={classNames.homeIconButtonSpacer} />;
  }, [shouldShowHome, OnHomePressCallback]);

  return (
    <div className={classNames.container}>
      <div className={classNames.homeIconButtonWrapper}>{HomeIconButtonElement}</div>
      <div className={classNames.childrenWrapper}>{children}</div>
    </div>
  );
});
